import React from 'react'
import Text from 'react-text'
import Plan from './plan'
import {Consumer} from '../../context'

export default function Group(props) {
  return (<Consumer>{context => {
    const {translate, groups} = context
    const plans = props.plans.map(plan => (<Plan key={plan.id} {...plan} />))
    return (
      <div className="plans">
        {plans}
      </div>
    )
  }}</Consumer>)
}
